import React, { useEffect, useState } from "react"
import Cleave from "cleave.js/react"
import "cleave.js/dist/addons/cleave-phone.br"
import * as _ from "lodash"
import PropTypes from "prop-types"
import API from "../Utils/api"
import { Link } from 'react-router-dom';


import { generatePassword, validateCPF, validateEmail } from "../Utils/validation";

const FormCambista = ({ perfil, id = null, redirect, history }) => {
    const initialState = {
        nome: '',
        email: '',
        telefone: '',
        cpf: '',
        endereco: '',
        bairro: '',
        cidade: '',
        estado: '',
        status: 'true',
        comissao: 5,
        tutorId: null,
    }
    const lists = {
        gerentes: []
    }
    const [resetSenha, setResetSenha] = useState(false)
    const [form, setForm] = useState(initialState);
    const [list, setList] = useState(lists);
    const [errors, setErrors] = useState({ nome: '', email: '', cpf: '' });
    const [cleaves, setCleaves] = useState({
        cpfCleave: null,
        telefoneCleave: null,
        emailCleave: null
    })

    useEffect(() => {
        buscarCambistaPeloId(id)
    }, [id])

    const buscarCambistaPeloId = async id => {
        if (id != null) {
            const { data } = await API.get(`/api/usuarios/${id}`)
            if (data) {
                const status = data.status ? 'true' : 'false'

                setForm(prevState => {
                    return {
                        ...prevState,
                        ...data,
                        status
                    }
                })
            }
        }
    }

    const getParametros = async () => {
        const { data } = await API.get(`/api/parametros/`)
        setForm(prevState => {
            return {
                ...prevState,
                comissao: data.baseComissaoCambista
            }
        })
    }

    const validateFields = ({ cpf, nome, email }) => {
        const errors = {};
        if (!nome) errors['nome'] = 'Nome é um campo obrigatório';
        if (nome && nome.length <= 3) errors['nome'] = 'Nome muito curto';
        if (!email) errors['email'] = 'Email é um campo obrigatório';
        if (!validateEmail(email)) errors['email'] = 'Email inválido';

        setErrors({ ...errors })
    }

    const telefoneInit = (cleave) => {
        setCleaves(prevState => {
            return {
                ...prevState,
                telefoneCleave: cleave,
            }
        })
    }

    const cpfInit = (cleave) => {
        setCleaves(prevState => {
            return {
                ...prevState,
                cpfCleave: cleave,
            }
        })
    }

    const emailInit = (cleave) => {
        setCleaves(prevState => {
            return {
                ...prevState,
                emailCleave: cleave,
            }
        })
    }

    const handleResetForm = event => {
        setForm(initialState)
        setErrors({})
        setResetSenha(false)
        for (let key in cleaves) {
            cleaves[key].setRawValue('')
        }
    }

    const handleInputChange = event => {
        const { name, value } = event.target
        console.log(name + " : " + value)
        setForm(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        })
    }

    const handleResetSenha = event => {
        const { checked } = event.target
        setResetSenha(checked)
    }

    const handleRequiredCleaveLength = event => {
        const minLength = event.target.dataset.length
        const { name, rawValue } = event.target

        if (rawValue && rawValue.length < minLength) {
            setForm(prevState => {
                return {
                    ...prevState,
                    [name]: ''
                }
            })
            cleaves[`${name}Cleave`].setRawValue('')
        }
    }

    const validateForm = async () => {
        validateFields({ ...form })
    }

    const listaGerentes = async () => {
        if (list.gerentes.length == 0)
            try {
                const response = await API.post("/api/usuarios/listar-todos-gerentes", {});
                setList({ gerentes: response.data })
            } catch (err) {
                console.log(err);
            }
    }

    listaGerentes();
    getParametros()

    const handleSubmit = async event => {
        event.preventDefault()
        let senha = ''
        const status = form.status === 'true'


        if (_.isEmpty(errors)) {
            if (!id) {
                senha = generatePassword()
                const response = await API.post('/api/usuarios/', {
                    ...form, perfil, senha, status
                })

                const responseError = response.data.error;
                if (responseError) {
                    alert(responseError)
                    return
                }

            } else {
                var dados;
                // atualizar o registro

                if (typeof form.tutorId === 'string') {
                    dados = { ...form, tutorId: form.tutorId, perfil, status, usuarioId: id }
                    console.log(1)
                }
                else {
                    console.log(2)
                    dados = { ...form, tutorId: form.tutorId._id, perfil, status, usuarioId: id }
                }

                var response;
                if (resetSenha) {
                    senha = generatePassword();
                    dados.senha = senha;
                    response = await API.post('/api/usuarios/atualizar-usuario', { ...dados });
                    console.log(dados);
                    console.log(response.data);
                }
                else {

                    response = await API.post('/api/usuarios/atualizar-usuario-manter-senha', { ...dados })

                }

                if (response.data === 1) {
                    let message = 'Registro atualizado com sucesso.'
                    if (resetSenha) message = message.concat(`\nAnote sua nova senha: ${senha}`)
                    alert(message)
                    if (redirect) {
                        history.push(`/${redirect}`)
                    }
                }
            }

            handleResetForm()

            if (!id) {
                alert(`
Cadastro realizado com sucesso.
Obs.: Anote a senha: ${senha}, email: ${form.email}
                `);
                if (redirect) {
                    history.push(`/${redirect}`)
                }
            }
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="form-group col-lg-9">
                    <label htmlFor="nome">NOME</label>
                    <input type="text" name="nome"
                        onChange={handleInputChange}
                        value={form.nome || ''}
                        className={`form-control ${errors.nome && 'is-invalid'}`} placeholder="Nome" />
                    <div className="invalid-feedback">
                        {errors.nome}
                    </div>
                </div>
                <div className="form-group col-lg-3">
                    <label htmlFor="cpf">CPF</label>
                    <Cleave placeholder="999.999.999-99"
                        value={form.cpf || ''}
                        name="cpf" data-length="11"
                        onInit={cpfInit}
                        className={`form-control ${errors.cpf && 'is-invalid'}`}
                        options={{
                            numericOnly: true,
                            delimiters: ['.', '.', '-'],
                            blocks: [3, 3, 3, 2]
                        }}
                        onChange={handleInputChange}
                        onBlur={handleRequiredCleaveLength}
                    />
                    <div className="invalid-feedback">
                        {errors.cpf}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-9">
                    <label htmlFor="email">EMAIL</label>
                    <Cleave name="email" placeholder="email@email.com" onInit={emailInit}
                        value={form.email || ''}
                        className={`form-control ${errors.email && 'is-invalid'}`}
                        options={{
                            lowercase: true,
                        }}
                        onChange={handleInputChange}
                    />
                    <div className="invalid-feedback">
                        {errors.email}
                    </div>
                </div>
                <div className="form-group col-lg-3">
                    <label htmlFor="telefone">TELEFONE</label>
                    <Cleave name="telefone"
                        placeholder="99 99999 9999"
                        data-length="10"
                        value={form.telefone || ''}
                        onInit={telefoneInit}
                        className="form-control"
                        options={{
                            phone: true,
                            phoneRegionCode: 'BR'
                        }}
                        onChange={handleInputChange}
                        onBlur={handleRequiredCleaveLength}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-7">
                    <label htmlFor="endereco">Endereço</label>
                    <input type="text" name="endereco" className="form-control" placeholder="Endereço"
                        value={form.endereco || ''}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-5">
                    <label htmlFor="bairro">Bairro</label>
                    <input type="text" name="bairro" className="form-control" placeholder="Bairro"
                        value={form.bairro || ''}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-5">
                    <label htmlFor="comissao">Comissão</label>
                    <input type="text" name="bairro" className="form-control" placeholder="5%"
                        value={form.comissao}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-5">
                    <label htmlFor="tutorId">Gerente</label><br />
                    <select name="tutorId" onChange={handleInputChange} class="custom-select">
                        <option name="tutorId" selected value={form.tutorId ? form.tutorId._id : ""}>{form.tutorId ? form.tutorId.nome : "Nenhum"}</option>
                        {list.gerentes.map((gerente, index) => {
                            return <option name='tutorId' value={gerente._id.toString()}>{gerente.nome}</option>
                        })}
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-4">
                    <label htmlFor="cidade">Cidade</label>
                    <input type="text" name="cidade" className="form-control" placeholder="Cidade"
                        value={form.cidade || ''}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-4">
                    <label htmlFor="estado">Estado</label>
                    <input type="text" name="estado" className="form-control" placeholder="Estado"
                        value={form.estado || ''}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-4">
                    <label htmlFor="status">Status</label>
                    <select id="status" name="status"
                        onChange={handleInputChange}
                        value={form.status || 'true'}
                        className="form-control custom-select"
                        style={{ height: 'calc(2.25rem + 4px)' }}>
                        <option value="">Selecione...</option>
                        <option value="true">Ativo</option>
                        <option value="false">Bloqueado</option>
                    </select>
                </div>
            </div>
            {id && (
                <div className="row">
                    <div className="col-lg-12">
                        <input type="checkbox" id="exampleCheck1" checked={resetSenha} onChange={handleResetSenha} />
                        <label className="form-check-label" htmlFor="exampleCheck1">Gerar nova senha ao salvar</label>
                    </div>
                </div>
            )}
            <div className="float-lg-right">
                {/* <button type="reset" onClick={handleResetForm} className="btn btn-fill btn-secondary">Cancelar
                </button> */}
                <Link to="master-gerencia-cambistas" className="btn btn-fill btn-secondary">Cancelar
                </Link>
                <button type="submit" onClick={validateForm}
                    className="btn btn-fill btn-success ml-lg-1 ml-md-1">Salvar
                </button>
            </div>
            <div className="clearfix"></div>
        </form>
    )
};

FormCambista.propTypes = {
    perfil: PropTypes.oneOf(['GERENTE', 'CAMBISTA', 'CLIENTE', 'SUBMASTER']).isRequired,
    id: PropTypes.string
}

export default FormCambista